<template>
    <div class="quotation-container" ref="quotationContent">
        <!-- 右上角信息部分 - 重构为更清晰的布局结构 -->
        <div class="header-top">
            <div class="logo-container">
                <img width="150px" :src="logoUrl" alt="Company Logo" class="logo">
            </div>
            <div class="doc-info">
                <div class="info-row">
                    <span class="info-label">{{ viewNoLabel }}</span>
                    <span class="info-value">{{ formattedDocNumber }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Date:</span>
                    <span class="info-value">{{ formattedDate }}</span>
                </div>
            </div>
        </div>
        <!-- 公司信息部分 - 增加语义化标记 -->
        <header class="company-header">
            <h1>{{ profile.companyname }}</h1>
            <div class="contact-info">
                <address class="company-address">Add: {{ profile.companylocation }}</address>
                <div class="contact-details">
                    <span class="contact-item">TEL: {{ profile.companytel }}</span>
                    <span class="contact-item">FAX: {{ profile.companyfax }}</span>
                    <span class="contact-item">Email: {{ profile.companyemail || 'sales@haomai.net' }}</span>
                </div>
            </div>
        </header>
        <h2 class="document-title">{{ docTitle }}</h2>
        <!-- 客户信息部分 - 增加数据安全检查和字段验证 -->
        <section class="customer-section" v-if="view !== 'PL'">
            <el-row :gutter="8" class="info-section">
                <el-col :span="12">
                    <div class="info-item">
                        <label>Buyer:</label>
                        <div class="info-content">{{ customerInfo?.companyname || 'N/A' }}</div>
                    </div>
                    <div class="info-item">
                        <label>Email:</label>
                        <div class="info-content">{{ contactInfo.email || 'N/A' }}</div>
                    </div>
                </el-col>
                <el-col :span="12">
                <div class="info-item">
                    <label>Attn:</label>
                    <div class="info-content">{{ contactInfo.fullname || 'N/A' }}</div>
                </div>
                <div class="info-item">
                    <label>Tel:</label>
                    <div class="info-content">{{ contactInfo.phone || 'N/A' }}</div>
                </div>
                </el-col>
                <el-col :span="24">    
                    <div class="info-item">        
                        <label>Add:</label>        
                        <div class="info-content">{{ customerInfo?.address || 'N/A' }}</div>
                    </div>
                </el-col>
                </el-row>
            <el-row :gutter="8" class="info-section">
                <el-col :span="24">
                    <div class="info-item">
                        <label>Incoterm:</label>
                        <div class="info-content">{{ quoteinfo?.incoterms || 'N/A' }} {{quoteinfo?.destination || 'Haomai Factory Address'}}</div>
                    </div>
                    <div class="info-item">
                        <label>Payment:</label>
                        <div class="info-content">{{quoteinfo?.paymentmethod }}</div>
                    </div>
                    <div class="info-item">
                        <label>Delivery:</label>
                        <div class="info-content">{{ quoteinfo?.deliveryterms ? quoteinfo.deliveryterms + ' working days after receiving deposit and finalized technical specs.' : 'N/A' }}</div>
                    </div>
                    <div class="info-item">
                        <label>CO.:</label>
                        <div class="info-content">Wuhan China</div>
                    </div>
                    <div class="info-item" v-if="view=='QUOTE'">
                        <label>Price validity</label>
                        <div class="info-content">
                            {{ quoteinfo?.validitydate ? 'Prices firm for ' + quoteinfo.validitydate + ' days from quotation date.' : 'longterm' }}
                        </div>
                    </div>
                </el-col>
            </el-row>
        </section>
        <!-- 装箱单（PL）专业版式：买卖双方块 / 装运信息 / 唛头 / 按箱编号明细 / 合计 / 备注 -->
        <section class="pl-sheet" v-if="view === 'PL'">
            <div class="pl-parties">
                <div class="pl-party">
                    <h4>Consignee / Buyer</h4>
                    <div class="pl-party-line"><label>Name:</label><span>{{ customerInfo?.companyname || 'N/A' }}</span></div>
                    <div class="pl-party-line"><label>Address:</label><span>{{ customerInfo?.address || 'N/A' }}</span></div>
                    <div class="pl-party-line"><label>Attn:</label><span>{{ contactInfo.fullname || 'N/A' }}</span></div>
                    <div class="pl-party-line"><label>Tel:</label><span>{{ contactInfo.phone || 'N/A' }}</span></div>
                    <div class="pl-party-line"><label>Email:</label><span>{{ contactInfo.email || 'N/A' }}</span></div>
                </div>
                <div class="pl-party">
                    <h4>Seller</h4>
                    <div class="pl-party-line"><label>Name:</label><span>{{ profile.companyname || 'N/A' }}</span></div>
                    <div class="pl-party-line"><label>Address:</label><span>{{ profile.companylocation || 'N/A' }}</span></div>
                    <div class="pl-party-line"><label>Tel:</label><span>{{ profile.companytel || 'N/A' }}</span></div>
                    <div class="pl-party-line"><label>Email:</label><span>{{ profile.companyemail || 'N/A' }}</span></div>
                </div>
            </div>
            <div class="pl-shipment">
                <div class="pl-shipment-item"><label>Port of Loading:</label><span>{{ quoteinfo?.port || '—' }}</span></div>
                <div class="pl-shipment-item"><label>Port of Discharge:</label><span>{{ quoteinfo?.destination || '—' }}</span></div>
                <div class="pl-shipment-item"><label>Country of Origin:</label><span>{{ quoteinfo?.countryoforigin || '—' }}</span></div>
                <div class="pl-shipment-item"><label>Incoterm:</label><span>{{ quoteinfo?.incoterms || '—' }}</span></div>
                <div class="pl-shipment-item"><label>Vessel / Flight:</label><span>—</span></div>
                <div class="pl-shipment-item"><label>B/L No.:</label><span>—</span></div>
                <div class="pl-shipment-item"><label>Shipment Date:</label><span>—</span></div>
                <div class="pl-shipment-item"><label>Container No.:</label><span>—</span></div>
            </div>
            <div class="pl-marks-box">
                <label>Marks &amp; Numbers:</label>
                <div class="pl-marks-content">N/M</div>
            </div>
            <el-table :data="plItems"
                      border
                      class="pl-table"
                      empty-text="No products in this packing list">
                <el-table-column label="Case No." width="55" align="center">
                    <template #default="{ $index }">
                        {{ plCaseRanges[$index] ? plCaseRanges[$index].from + '-' + plCaseRanges[$index].to : '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="productcode" label="Model" width="90" align="center" />
                <el-table-column label="Description" align="left">
                    <template #default="{row}">
                        {{ row.productname || 'N/A' }}; {{ row.description || 'N/A' }}
                    </template>
                </el-table-column>
                <el-table-column prop="quantity" label="Qty" width="50" align="center" />
                <el-table-column label="Ctns" width="55" align="center">
                    <template #default="{row}">{{ plCartons(row) }}</template>
                </el-table-column>
                <el-table-column label="N.W.(kg)" width="65" align="center">
                    <template #default="{row}">{{ fmtNum(plNW(row)) }}</template>
                </el-table-column>
                <el-table-column label="G.W.(kg)" width="65" align="center">
                    <template #default="{row}">{{ fmtNum(plGW(row)) }}</template>
                </el-table-column>
                <el-table-column label="Meas.(cm)" width="110" align="center">
                    <template #default="{row}">{{ pkgSize(row) }}</template>
                </el-table-column>
                <el-table-column label="Vol(m³)" width="75" align="center">
                    <template #default="{row}">{{ fmtVol(plVol(row)) }}</template>
                </el-table-column>
            </el-table>
            <div class="pl-totals">
                <span class="pl-total-label">Total:</span>
                <span>Qty: {{ totalQty }}</span>
                <span>Ctns: {{ plTotalCtns }}</span>
                <span>N.W.: {{ fmtNum(totalNW) }} kg</span>
                <span>G.W.: {{ fmtNum(totalGW) }} kg</span>
                <span>Vol: {{ fmtVol(plTotalVol) }} m³</span>
            </div>
            <div class="pl-remarks">
                <label>Remarks:</label>
                <p>1. Made in China.</p>
                <p>2. Packing suitable for international transport.</p>
                <p>Total packages: {{ plTotalCtns }} cartons</p>
            </div>
        </section>
        <!-- 产品部分 - 增加空状态处理；报价/PI/CI 显示金额明细 -->
        <section class="products-section" v-if="view !== 'PL'">
            <el-table :data="items"
                      border
                      empty-text="No products in this document"
                      >
                <el-table-column type="index"
                                 label="SN"
                                 width="45"
                                 align="center" />
                <el-table-column prop="productcode"
                                 label="Model"
                                 width="100"
                                 align="center" />
                <el-table-column label="Description"
                                 align="left">
                    <template #default="{row}">
                        {{row.productname||'N/A'}};
                        {{ row.description || 'N/A'}};
                        <strong>;Warranty:</strong>
                        {{row.warranty||'N/A' }} Months;
                    <span v-if="row.itemnote"><strong>Notes:</strong>{{row.itemnote||'N/A'}}</span>
                    <span v-if="row.hscode"><strong>HsCode:</strong>{{row.hscode||'N/A'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="quantity"
                                 label="Q'ty"
                                 width="52"
                                 align="center" />
                <el-table-column prop="unitprice"
                                 label="Price"
                                 width="80"
                                 align="center">
                    <template #default="{row}">
                        {{ formatCurrency(row.unitprice) }}
                    </template>
                </el-table-column>
                <el-table-column prop="amount"
                                 label="Amount"
                                 width="80"
                                 align="right">
                    <template #default="{row}">
                        {{ formatCurrency(row.unitprice*row.quantity) }}
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <!-- 总计部分（报价/PI/CI） -->
        <div class="summary-section" v-if="view !== 'PL'">
            <div class="total-amount">
                <span class="summary-label">Total Amount {{ formatCurrency(quoteinfo.totalamount) }}</span>
                <span class="summary-value">{{ wordAmount }}</span>
            </div>
        </div>
        <section class="customer-section" v-if="view=='PI' || view=='CI'">
            <el-row :gutter="8" class="info-section">
                <el-col :span="24">
                    <div class="info-item">
                        <label>Bank Details:</label>
                        <div class="info-content"></div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="info-item">
                        <label>BeneficiaryName:</label>
                        <div class="info-content">{{profile.beneficiaryname}}</div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="info-item">
                        <label>BeneficiaryBank:</label>
                        <div class="info-content">{{profile.beneficiarybank}}</div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="info-item">
                        <label>BeneficiaryBankAddress:</label>
                        <div class="info-content">{{profile.beneficiarybankaddress}}</div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="info-item">
                        <label>AccountNo.:</label>
                        <div class="info-content">{{profile.accountno}}</div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="info-item">
                        <label>SwiftCode:</label>
                        <div class="info-content">{{profile.swiftcode}}</div>
                    </div>
                </el-col>
            </el-row>
        </section>

        <!-- 签名部分 - 增加动态签名人 -->
        <footer class="signature-section">
            <div class="signature-box">
                <h4 class="signature-title">Confirmed by Seller</h4>
                <div class="company-name">{{ profile.companyname || 'HAOMAI ELECTRIC POWER AUTOMATION' }}</div>
                <div class="signature-line">   <img :src="signature" alt="Alternate Text" style="width:120px;transform:translate(0,-20px)" /></div>
                <div class="signer-info">
                    <span>Signed by: {{ signerName }}</span>
                    <span>Date: {{ (quoteinfo.issuedate || '').split(" ")[0] }}</span>
                </div>
            </div>
        </footer>

        <!-- 操作按钮（视图感知：报价单→PI→(转订单/录到款→CI)→PL 一键流转） -->
        <div v-if="!isPrinting" class="action-bar">
            <el-button type="primary" @click="downloadPDF" :loading="isGeneratingPDF">
                <span v-if="!isGeneratingPDF">Download PDF</span>
                <span v-else>Generating...</span>
            </el-button>
            <el-button type="success" @click="sendMail" :loading="isPreparingMail">
                <span v-if="!isPreparingMail">发送邮件</span>
                <span v-else>Generating...</span>
            </el-button>
            <template v-if="view === 'QUOTE'">
                <el-button type="warning" @click="generatePI" :loading="isGeneratingPI">
                    {{ isGeneratingPI ? '生成中...' : '生成 PI' }}
                </el-button>
            </template>
            <template v-else-if="view === 'PI'">
                <el-button type="primary" @click="generateOrder" :loading="isGeneratingOrder">
                    {{ isGeneratingOrder ? '跳转中...' : '转订单' }}
                </el-button>
                <el-button type="danger" @click="generateCI" :loading="isGeneratingCI">
                    {{ isGeneratingCI ? '生成中...' : '生成 CI' }}
                </el-button>
            </template>
            <template v-else-if="view === 'CI'">
                <el-button type="success" @click="generatePL" :loading="isGeneratingPL">
                    {{ isGeneratingPL ? '生成中...' : '生成 PL' }}
                </el-button>
            </template>
        </div>
    </div>

    <sendmail ref="sendmail" />

    <!-- 到款金额对话框：登记到款后即可生成 CI（同步到关联订单） -->
    <el-dialog v-model="ciDepositDialog" title="登记到款并生成 CI" width="440px" :close-on-click-modal="false">
        <div style="padding: 4px 6px;">
            <p style="margin: 0 0 14px 0; color: #606266; line-height: 1.6;">
                登记到款后即可生成 CI（到款金额会同步到关联订单，作为后续生成 CI/PL 的前提）。
            </p>
            <el-form label-width="90px" @submit.prevent>
                <el-form-item label="到款金额">
                    <el-input-number v-model="ciDeposit" :min="0" :precision="2" :controls-position="'right'" style="width:100%" />
                </el-form-item>
            </el-form>
        </div>
        <template #footer>
            <el-button @click="ciDepositDialog = false">取消</el-button>
            <el-button type="primary" @click="confirmCIDeposit" :loading="isGeneratingCI">确认并生成</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import html2canvas from 'html2canvas';
    import jsPDF from 'jspdf';
    import axios from "axios";
    import Qs from "qs";
    import { numberToWords } from "../utils/numberToWords";
    import { resolveImageUrl } from '@/utils/imageUrl';
    import sendmail from './sendmail';

    // 使用require.context预创建签名图片上下文（webpack 5兼容写法）
    const signatureContext = require.context('../assets', false, /\.(png|jpe?g|gif|svg)$/);

    export default {
        name: 'QuotationDocument',
        components: { sendmail },
        emits: ['changed'],
        props: {
            // 兼容旧用法：quotation.vue 传 doc/cust 静态预览；
            // 通用预览请用 openDoc(doc, cust) 动态打开任意单证（报价单/PI/CI/PL）
            doc: {
                type: Object,
                default: () => ({})
            },
            cust: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                quoteinfo: this.doc || {},   // 当前单证（含 prop 传入或 openDoc 打开）
                customerInfo: this.cust || {}, // 当前客户
                view: 'QUOTE',               // 'QUOTE' | 'PI' | 'CI' | 'PL'
                isLoading: false,
                isGeneratingPDF: false,
                isPreparingMail: false,
                isGeneratingPI: false,
                isGeneratingOrder: false,
                isGeneratingCI: false,
                isGeneratingPL: false,
                isPrinting: false,
                ciDeposit: 0,
                ciDepositDialog: false,
                signature: '', // 签名图片
                profile: {
                    companyname: '',
                    companylocation: '',
                    companytel: '',
                    companyfax: '',
                    companyemail: '',
                    logo: ''
                },
                items: [], // 初始为空数组，通过API或prop填充
                contacts: [], // 客户联系人列表（未随 customerInfo 传入时按 companyid 拉取）
                signerName: '',
            };
        },
        computed: {
            // 报价单/PI/CI/PL 共用同一编号（后端 generate_doc 已继承源单号）
            formattedDocNumber() {
                if (this.quoteinfo.docnumber) return this.quoteinfo.docnumber;
                if (this.quoteinfo.documentid) return `DOC-${this.quoteinfo.documentid}`;
                return 'N/A';
            },
            docTitle() {
                switch (this.view) {
                    case 'QUOTE': return 'QUOTATION SHEET';
                    case 'PI': return 'PROFORMA INVOICE';
                    case 'CI': return 'COMMERCIAL INVOICE';
                    case 'PL': return 'PACKING LIST';
                    default: return 'QUOTATION SHEET';
                }
            },
            viewNoLabel() {
                switch (this.view) {
                    case 'QUOTE': return 'Quotation No.:';
                    case 'PI': return 'Proforma Invoice No.:';
                    case 'CI': return 'Commercial Invoice No.:';
                    case 'PL': return 'Packing List No.:';
                    default: return 'Document No.:';
                }
            },
            plItems() {
                // 装箱明细行：仅保留含重量/尺寸信息的行（折扣行无重量/尺寸，自动隐藏）
                return (this.items || []).filter(it =>
                    it.netweight || it.grossweight || it.pkglength || it.pkgwidth || it.pkgheight
                );
            },
            totalQty() {
                return (this.plItems || []).reduce((s, it) => s + (Number(it.quantity) || 0), 0);
            },
            // 每行箱数 = 数量 ÷ 每箱数量（向上取整；每箱数量空值按 1）
            plCartons(row) {
                const qty = Number(row.quantity) || 0;
                const perCtn = Number(row.packingqty) || 1;
                if (qty <= 0) return 0;
                return Math.ceil(qty / Math.max(perCtn, 1));
            },
            // 单行净重合计 = 单件净重 × 数量
            plNW(row) {
                const v = (Number(row.quantity) || 0) * (Number(row.netweight) || 0);
                return Math.round(v * 100) / 100;
            },
            // 单行毛重合计 = 单件毛重 × 数量
            plGW(row) {
                const v = (Number(row.quantity) || 0) * (Number(row.grossweight) || 0);
                return Math.round(v * 100) / 100;
            },
            // 单箱体积 (m³) = 长×宽×高(cm) ÷ 1e6
            plVolCtn(row) {
                const L = Number(row.pkglength) || 0;
                const W = Number(row.pkgwidth) || 0;
                const H = Number(row.pkgheight) || 0;
                return (L * W * H) / 1e6;
            },
            // 单行总体积 (m³) = 单箱体积 × 箱数
            plVol(row) {
                return this.plVolCtn(row) * this.plCartons(row);
            },
            // 累计箱号区间（如 1-2、3-5），按每行箱数累加
            plCaseRanges() {
                const ranges = [];
                let acc = 0;
                for (const it of this.plItems) {
                    const c = this.plCartons(it);
                    const from = acc + 1;
                    const to = acc + c;
                    ranges.push({ from, to });
                    acc += c;
                }
                return ranges;
            },
            totalNW() {
                return (this.plItems || []).reduce((s, it) => s + this.plNW(it), 0);
            },
            totalGW() {
                return (this.plItems || []).reduce((s, it) => s + this.plGW(it), 0);
            },
            plTotalCtns() {
                return (this.plItems || []).reduce((s, it) => s + this.plCartons(it), 0);
            },
            plTotalVol() {
                return (this.plItems || []).reduce((s, it) => s + this.plVol(it), 0);
            },
            formattedDate() {
                if (!this.quoteinfo.issuedate) return 'N/A';

                const date = new Date(this.quoteinfo.issuedate);
                const day = date.getDate();
                const month = date.toLocaleString('en-US', { month: 'long' });
                const year = date.getFullYear();

                // 获取日期后缀（st, nd, rd, th）
                let suffix;
                if (day > 3 && day < 21) suffix = 'th';
                else {
                    switch (day % 10) {
                        case 1: suffix = 'st'; break;
                        case 2: suffix = 'nd'; break;
                        case 3: suffix = 'rd'; break;
                        default: suffix = 'th';
                    }
                }

                return `${month} ${day}${suffix},${year}`;
            },

            wordAmount() {
                return numberToWords(Number(this.quoteinfo.totalamount) || 0);
            },
            // 单据抬头联系人：优先「本单所选联系人（Buyerno）」，否则取客户联系人第一个
            contactInfo() {
                let list = (this.customerInfo && Array.isArray(this.customerInfo.contacts) && this.customerInfo.contacts.length)
                    ? this.customerInfo.contacts
                    : (Array.isArray(this.contacts) && this.contacts.length ? this.contacts : []);
                const bno = this.quoteinfo && this.quoteinfo.buyerno;
                if (bno !== null && bno !== undefined && bno !== '' && list.length) {
                    const found = list.find(c => Number(c.contactid) === Number(bno));
                    if (found) return found;
                }
                return list[0] || {};
            },

            currentDate() {
                return new Date().toLocaleDateString('en-US');
            },

            // 公司 Logo：优先运行时上传（companylogopath），否则回退打包默认 logo
            logoUrl() {
                const p = (this.profile && (this.profile.companylogopath || this.profile.logo));
                if (p) return resolveImageUrl(p);
                return require('../assets/logo.png');
            }
        },
        created() {
            this.fetchcompanyinfo();
            this.initData();
            this.fetchQuoteproducts()
            this.fetchsalesinfo()
        },
        methods: {
            //获取销售员信息
            async fetchsalesinfo() {
                console.log('Fetching sales info for ownerid:', this.customerInfo.ownerid);
                if (!this.customerInfo.ownerid) return;
                this.isLoading = true;

                try {
                    const response = await axios({
                        url: '/apiserve/crmapi/documents.asp',
                        method: 'post',
                        transformRequest: [function (data) {
                            return Qs.stringify(data);
                        }],
                        data: {
                            action: 'users',
                            userid: this.customerInfo.ownerid,
                            profileid: this.quoteinfo.profileid || ''
                        }
                    });

                    console.log('Sales Info Response:', response.data);
                    const salesInfo = response.data?.salesinfo?.[0];
                    this.signerName = salesInfo?.signaturename || 'N/A';

                    // 安全加载签名图片：运行时上传（Uploads/… 或 http(s)/绝对路径）走 URL 解析；
                    // 旧打包资源名保持 require.context 兼容
                    const sigPath = salesInfo?.signaturepath;
                    if (sigPath) {
                        if (/^https?:\/\//i.test(sigPath) || sigPath.startsWith('/') || sigPath.toLowerCase().startsWith('uploads/')) {
                            this.signature = resolveImageUrl(sigPath);
                        } else {
                            try {
                                // 使用require.context方式加载（webpack 5兼容）
                                this.signature = signatureContext('./' + sigPath);
                            } catch (requireErr) {
                                console.error('签名图片加载失败，路径:', sigPath, requireErr);
                                this.signature = '';
                            }
                        }
                    } else {
                        console.warn('用户未设置签名图片，ownerid:', this.customerInfo.ownerid);
                        this.signature = '';
                    }
                } catch (error) {
                    console.error('获取销售员信息失败:', error);
                    this.signerName = 'N/A';
                    this.signature = '';
                } finally {
                    this.isLoading = false;
                }

            },

            //切换视图
            viewchange(v) {
                console.log('Switching view to:', v);
                this.view = String(v).toUpperCase();
            },

            // 通用打开任意单证（报价单/PI/CI/PL）：供单证管理页/商机页复用
            openDoc(doc, cust) {
                if (!doc) return;
                // 清空上一单数据，避免闪现旧内容
                this.items = [];
                this.signature = '';
                this.signerName = '';

                const dt = Number(doc.doctype) || 2;
                const hasSource = doc.sourcedocumentid && Number(doc.sourcedocumentid) > 0;
                this.view = dt === 4 ? 'PL' : (dt === 3 ? 'CI' : (hasSource ? 'PI' : 'QUOTE'));

                this.quoteinfo = doc || {};
                const hasContacts = cust && Array.isArray(cust.contacts) && cust.contacts.length;
                this.customerInfo = cust || {};
                if (!hasContacts) this.fetchContacts();

                this.fetchcompanyinfo();
                this.fetchQuoteproducts();
                this.fetchsalesinfo();
                return this.view;
            },
            // 拉取客户联系人（预览 Attn/Email 按本单 Buyerno 选中人显示）
            async fetchContacts() {
                const cid = this.quoteinfo && (this.quoteinfo.companyid || this.quoteinfo.companyId);
                if (!cid) return;
                try {
                    const response = await axios({
                        url: '/apiserve/crmapi/customersapi.asp',
                        method: 'post',
                        transformRequest: [function (data) { return Qs.stringify(data); }],
                        data: { action: 'getcontactlist', companyid: cid }
                    });
                    const data = response.data;
                    this.contacts = Array.isArray(data) ? data
                        : (data && Array.isArray(data.data) ? data.data : []);
                } catch (e) {
                    console.error('fetchContacts error', e);
                    this.contacts = [];
                }
            },

            // 生成 PI（报价单 -> PI），已生成不重复生成；成功后在本抽屉内切到 PI 视图
            async generatePI() {
                if (!this.quoteinfo || !this.quoteinfo.documentid) {
                    this.$message.error('缺少报价单ID');
                    return;
                }
                this.isGeneratingPI = true;
                try {
                    const res = await axios({
                        url: '/apiserve/crmapi/documents.asp',
                        method: 'post',
                        transformRequest: [function (data) {
                            return Qs.stringify(data);
                        }],
                        data: {
                            action: 'generatedoc',
                            sourcedocid: this.quoteinfo.documentid,
                            doctype: 2
                        }
                    });
                    if (res.data && res.data.success) {
                        if (res.data.already_exists) {
                            this.$message.info('PI 已存在，直接打开');
                        } else {
                            this.$message.success('PI 生成成功');
                        }
                        // 切到本抽屉 PI 视图（不再弹旧 tradedoc-drawer）
                        const piDoc = {
                            ...this.quoteinfo,
                            documentid: res.data.documentid,
                            docnumber: res.data.docnumber,
                            doctype: 2,
                            sourcedocumentid: this.quoteinfo.documentid
                        };
                        this.openDoc(piDoc, this.customerInfo);
                        this.$emit('changed');
                    } else {
                        this.$message.error(res.data && res.data.error ? res.data.error : 'PI 生成失败');
                    }
                } catch (e) {
                    console.error('generatePI error', e);
                    this.$message.error('PI 生成失败');
                } finally {
                    this.isGeneratingPI = false;
                }
            },

            // 转订单：把当前 PI/报价单全详细信息带到订单页（含产品明细/贸易条款/联系人）
            generateOrder() {
                const doc = this.quoteinfo || {};
                if (!doc.documentid) {
                    this.$message.error('缺少单证ID');
                    return;
                }
                this.isGeneratingOrder = true;
                const products = (this.items || []).map(it => ({
                    productid: it.productid || '',
                    productcode: it.productcode || '',
                    description: it.description || '',
                    quantity: it.quantity || 1,
                    unitprice: it.unitprice || 0
                }));
                const q = {
                    fromQuote: '1',
                    documentid: doc.documentid,
                    companyid: (this.customerInfo && this.customerInfo.companyid) || doc.companyid || '',
                    companyname: (this.customerInfo && this.customerInfo.companyname) || '',
                    currency: doc.currency || 'USD',
                    totalamount: doc.totalamount || '',
                    incoterms: doc.incoterms || '',
                    paymentmethod: doc.paymentmethod || '',
                    deliveryterms: doc.deliveryterms || '',
                    destination: doc.destination || '',
                    port: doc.port || '',
                    countryoforigin: doc.countryoforigin || '',
                    contactid: (this.contactInfo && this.contactInfo.contactid) || '',
                    docnumber: doc.docnumber || '',
                    products: JSON.stringify(products)
                };
                this.$router.push({ path: '/orders', query: q });
                // 跳转后由 orders.vue created() 读取；按钮 loading 短暂复位兜底
                setTimeout(() => { this.isGeneratingOrder = false; }, 800);
            },

            // 生成 CI：无到款时打开到款金额对话框，登记到款后自动生成
            async generateCI() {
                const doc = this.quoteinfo || {};
                const piId = doc.documentid;
                if (!piId) {
                    this.$message.error('缺少 PI 单ID');
                    return;
                }
                this.isGeneratingCI = true;
                try {
                    const res = await this._callGeneratedoc(piId, 3, '');
                    if (res.data && res.data.success) {
                        this._afterGenerateCI(res.data);
                        return;
                    }
                    const err = (res.data && res.data.error) || '';
                    if (err.indexOf('登记到款') !== -1) {
                        this.ciDeposit = 0;
                        this.ciDepositDialog = true;
                    } else {
                        this.$message.error(err || 'CI 生成失败');
                    }
                } catch (e) {
                    console.error('generateCI error', e);
                    this.$message.error('CI 生成失败');
                } finally {
                    this.isGeneratingCI = false;
                }
            },

            // 到款金额对话框确认：带 deposit 再调 generatedoc，登记到款 + 生成 CI
            async confirmCIDeposit() {
                const amount = Number(this.ciDeposit) || 0;
                if (amount <= 0) {
                    this.$message.warning('请输入大于 0 的到款金额');
                    return;
                }
                const piId = this.quoteinfo && this.quoteinfo.documentid;
                if (!piId) { return; }
                this.ciDepositDialog = false;
                this.isGeneratingCI = true;
                try {
                    const res = await this._callGeneratedoc(piId, 3, amount);
                    if (res.data && res.data.success) {
                        this._afterGenerateCI(res.data);
                    } else {
                        this.$message.error((res.data && res.data.error) || 'CI 生成失败');
                    }
                } catch (e) {
                    console.error('generateCI with deposit error', e);
                    this.$message.error('CI 生成失败');
                } finally {
                    this.isGeneratingCI = false;
                }
            },

            // 生成 PL（从 PI 源单）：成功后切 PL 装箱视图
            async generatePL() {
                const doc = this.quoteinfo || {};
                const piId = (doc.sourcedocumentid && Number(doc.sourcedocumentid) > 0) ? doc.sourcedocumentid : doc.documentid;
                if (!piId) {
                    this.$message.error('缺少源单ID');
                    return;
                }
                this.isGeneratingPL = true;
                try {
                    const res = await this._callGeneratedoc(piId, 4, '');
                    if (res.data && res.data.success) {
                        if (res.data.already_exists) {
                            this.$message.info('PL 已存在，直接打开');
                        } else {
                            this.$message.success('PL 生成成功');
                        }
                        const plDoc = {
                            ...this.quoteinfo,
                            documentid: res.data.documentid,
                            docnumber: res.data.docnumber,
                            doctype: 4,
                            sourcedocumentid: piId
                        };
                        this.openDoc(plDoc, this.customerInfo);
                        this.$emit('changed');
                    } else {
                        this.$message.error(res.data && res.data.error ? res.data.error : 'PL 生成失败');
                    }
                } catch (e) {
                    console.error('generatePL error', e);
                    this.$message.error('PL 生成失败');
                } finally {
                    this.isGeneratingPL = false;
                }
            },

            // generatedoc 统一调用（deposit > 0 时携带）
            async _callGeneratedoc(sourcedocid, doctype, deposit) {
                const data = { action: 'generatedoc', sourcedocid, doctype };
                if (deposit !== '' && deposit !== null && Number(deposit) > 0) data.deposit = deposit;
                return await axios({
                    url: '/apiserve/crmapi/documents.asp',
                    method: 'post',
                    transformRequest: [function (d) { return Qs.stringify(d); }],
                    data
                });
            },

            // CI 生成成功（含已存在）：切到本抽屉 CI 视图
            _afterGenerateCI(genResult) {
                if (genResult.already_exists) {
                    this.$message.info('CI 已存在，直接打开');
                } else {
                    this.$message.success('CI 生成成功');
                }
                const ciDoc = {
                    ...this.quoteinfo,
                    documentid: genResult.documentid,
                    docnumber: genResult.docnumber,
                    doctype: 3,
                    sourcedocumentid: this.quoteinfo.documentid
                };
                this.openDoc(ciDoc, this.customerInfo);
                this.$emit('changed');
            },

            //获取报价单产品列表（报价/PI/CI/PL 共用：后端按 documentid 返回明细）
            async fetchQuoteproducts() {
                if (!this.quoteinfo.documentid) return;
                this.isLoading = true;
                try {
                    const response = await axios({
                        url: '/apiserve/crmapi/documents.asp',
                        method: 'post',
                        transformRequest: [function (data) {
                            return Qs.stringify(data);
                        }],
                        data: {
                            action: 'quotationitems',
                            documentid: this.quoteinfo.documentid
                        }
                    });
                    this.items = response.data.quotitems || [];
                } catch (error) {
                    console.log(error)
                } finally { this.isLoading = false; }

            },
            // 装箱单数值显示（空值显示 0，保留 2 位小数防浮点长尾）
            fmtNum(v) {
                const n = Number(v);
                if (isNaN(n)) return '0';
                return String(Math.round(n * 100) / 100);
            },
            // 装箱单体积显示（保留 3 位小数 m³）
            fmtVol(v) {
                const n = Number(v);
                if (isNaN(n)) return '0.000';
                return n.toFixed(3);
            },
            // 装箱单尺寸拼接：长x宽x高（cm）
            pkgSize(row) {
                const dims = [row.pkglength, row.pkgwidth, row.pkgheight]
                    .map(v => { const n = Number(v); return isNaN(n) ? '' : String(n); })
                    .filter(Boolean);
                return dims.length ? dims.join(' x ') : '-';
            },
            //获取公司信息
            async fetchcompanyinfo() {
                this.isLoading = true;
                try {
                    const response = await axios({
                        url: '/apiserve/crmapi/system.asp',
                        method: 'post',
                        transformRequest: [function (data) {
                            return Qs.stringify(data);
                        }],
                        data: {
                            action: 'profile',
                            profileid: this.quoteinfo.profileid || '1',
                        }
                    });
                    if (response.data?.profile?.[0]) {
                        this.profile = response.data.profile[0];
                        // logoUrl 由 computed 解析（companylogopath 优先，回退打包默认）
                    }
                } catch (error) {
                    console.error('Error fetching company info:', error);
                    this.$message.error('Failed to load company information');
                } finally {
                    this.isLoading = false;
                }
            },
            initData() {
                // 如果有props传入数据，可以在这里初始化
                if (this.$props.items && Array.isArray(this.$props.items)) {
                    this.items = this.$props.items;
                }
            },
            formatCurrency(value) {
                const v = Number(value);
                if (isNaN(v)) return '$0.00';
                const cur = (this.quoteinfo && (this.quoteinfo.currency || this.quoteinfo.currencycode)) || 'USD';
                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: cur,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(v);
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = 'Total';
                        return;
                    }
                    if (column.property === 'amount' || column.property === 'unitPrice' || column.property === 'quantity') {
                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0);

                            if (column.property === 'amount') {
                                sums[index] = this.formatCurrency(sums[index]);
                            } else if (column.property === 'unitPrice') {
                                // 对单价列不求和
                                sums[index] = '-';
                            } else {
                                sums[index] = sums[index].toFixed(0);
                            }
                        } else {
                            sums[index] = '-';
                        }
                    } else {
                        sums[index] = '-';
                    }
                });

                return sums;
            },
            async buildPdfBlob() {
                // 进入打印模式 (隐藏非内容元素)
                this.isPrinting = true;
                try {
                    // 等待DOM更新
                    await this.$nextTick();

                    const element = this.$refs.quotationContent;
                    const canvas = await html2canvas(element, {
                        scale: 2,
                        logging: false,
                        useCORS: true,
                        backgroundColor: '#FFFFFF',
                        scrollX: 0,
                        scrollY: 0
                    });

                    const imgData = canvas.toDataURL('image/png');
                    const pdf = new jsPDF({
                        orientation: 'portrait',
                        unit: 'mm',
                        format: 'a4'
                    });

                    // 计算PDF尺寸
                    const imgWidth = 190; // 留边距
                    const pageHeight = 277; // 297 - 10*2 (上下边距)
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;
                    let heightLeft = imgHeight;
                    let position = 10; // 起始位置(上边距)
                    let pageNum = 1;

                    // 添加第一页
                    pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight, `page${pageNum}`, 'FAST');
                    heightLeft -= pageHeight;

                    // 如果内容超过一页，添加新页
                    while (heightLeft >= -pageHeight) {
                        position = heightLeft - imgHeight + 10;
                        pdf.addPage();
                        pageNum++;
                        pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight, `page${pageNum}`, 'FAST');
                        heightLeft -= pageHeight;
                    }

                    // 恢复非打印状态
                    const docNameMap = { QUOTE: 'Quotation', PI: 'Proforma_Invoice', CI: 'Commercial_Invoice', PL: 'Packing_List' };
                    const filename = `${docNameMap[this.view] || 'Document'}_${this.formattedDocNumber}.pdf`;
                    return { blob: pdf.output('blob'), filename };
                } finally {
                    this.isPrinting = false;
                }
            },
            async downloadPDF() {
                this.isGeneratingPDF = true;
                try {
                    const { blob, filename } = await this.buildPdfBlob();
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                } catch (error) {
                    console.error('Error generating PDF:', error);
                    this.$message.error('Failed to generate PDF. Please try again.');
                } finally {
                    this.isGeneratingPDF = false;
                }
            },
            async sendMail() {
                this.isPreparingMail = true;
                try {
                    const { blob, filename } = await this.buildPdfBlob();
                    const recipient = this.contactInfo.email || this.customerInfo?.email || '';
                    const docTitleMap = { QUOTE: 'Quotation', PI: 'Proforma Invoice', CI: 'Commercial Invoice', PL: 'Packing List' };
                    const subject = `${docTitleMap[this.view] || 'Document'} ${this.formattedDocNumber}`;
                    const companyid = this.customerInfo?.companyid || this.quoteinfo?.companyid || 0;
                    const doctypeMap = { QUOTE: 2, PI: 2, CI: 3, PL: 4 };
                    this.$refs.sendmail.open({
                        recipient,
                        subject,
                        filename,
                        blob,
                        companyid,
                        contactid: this.contactInfo.contactid || null,
                        documentid: this.quoteinfo?.documentid || 0,
                        doctype: doctypeMap[this.view] || 0,
                        opportunityid: this.customerInfo?.opportunityid || 0,
                    });
                } catch (error) {
                    console.error('Error generating PDF:', error);
                    this.$message.error('Failed to generate PDF. Please try again.');
                } finally {
                    this.isPreparingMail = false;
                }
            },
        }
    };
</script>
<style scoped>
    /* 基础样式 */
    .quotation-container {
        font-family: "Arial", sans-serif;
        width: 210mm;
        min-height: 200mm;
        margin: 0 auto;
        padding: 5mm 5mm;
        box-sizing: border-box;
        background-color: white;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
        position: relative;
        color: #333;
        line-height: 1.5;
    }

    /* 头部布局 */
    .header-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 5mm;
    }

    .logo-container {
        flex: 0 0 auto;
    }

        .logo-container .logo {
            max-height: 30mm;
            object-fit: contain;
            filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.1));
        }

    .doc-info {
        text-align: right;
    }

        .doc-info .info-row {
            margin-bottom: 2mm;
            display: flex;
            justify-content: flex-end;
        }

            .doc-info .info-row:last-child {
                margin-bottom: 0;
            }

        .doc-info .info-label {
            font-weight: bold;
            margin-right: 5mm;
            min-width: 20mm;
            color: #1a1a1a;
        }

        .doc-info .info-value {
            text-align: left;
            min-width: 30mm;
            font-family: 'Courier New', monospace;
        }

    /* 公司信息 */
    .company-header {
        text-align: center;
        margin-bottom: 1mm;
    }

        .company-header h1 {
            font-size: 24px;
            margin-bottom: 5px;
            color: #1a2b50;
            text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
            letter-spacing: 0.5px;
        }

        .company-header .contact-info {
            font-size: 12px;
            line-height: 1.8;
            color: #666;
        }

        .company-header .company-address {
            font-style: normal;
            margin-bottom: 3px;
        }

        .company-header .contact-item {
            display: inline-block;
            margin: 0 10px;
            white-space: nowrap;
        }

            .company-header .contact-item:first-child {
                margin-left: 0;
            }

            .company-header .contact-item:last-child {
                margin-right: 0;
            }

    /* 文档标题 */
    .document-title {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        margin: 0 0 3mm 0;
        padding-bottom: 1mm;
        border-bottom: 2px solid #1a2b50;
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    /* 客户信息部分 */
    .customer-section {
        margin-bottom: 3mm;
    }

        .customer-section .info-section {
            border: 1px solid #eee;
            padding: 2mm;
            background-color: #f5f7fa;
            border-radius: 4px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
            line-height: 1.2;
        }

        .customer-section .info-item {
            margin-bottom: 3px;
            display: flex;
            min-height: 7mm;
            line-height: 1.2;
        }

            .customer-section .info-item:last-child {
                margin-bottom: 0;
            }

            .customer-section .info-item label {
                font-weight: bold;
                min-width: 30mm;
                color: #1a1a1a;
                font-size: 14px;
                vertical-align: top;
                line-height: 1.2;
                margin: 1px;
            }

            .customer-section .info-item .info-content {
                flex: 1;
                font-size: 14px;
                word-break: break-word;
                vertical-align: top;
                line-height: 1.2;
                margin: 1px;
            }

    /* 产品表格样式 */
    .products-section {
        margin-bottom: 2mm;
    }

        .products-section .section-title {
            font-weight: bold;
            margin-bottom: 1mm;
            color: #1a2b50;
            padding-bottom: 1px;
            border-bottom: 1px solid #eee;
            font-size: 12px;
        }

    ::v-deep(.el-table .cell) {
        padding: 1px 1px;
        padding-top: 1px;
        padding-bottom: 1px;
        line-height: 1.1;
    }


    /* 总计部分 */
    .summary-section {
        margin-bottom: 3mm;
        text-align: right;
    }

        .summary-section .total-amount {
            padding: 6px 10px;
            background-color: #f5f7fa;
            border: 1px solid #ddd;
            border-radius: 4px;
            display: inline-block;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        }

            .summary-section .total-amount .summary-label {
                font-weight: bold;
                margin-right: 20px;
                font-size: 16px;
                color: #1a2b50;
            }

            .summary-section .total-amount .summary-value {
                font-size: 18px;
                font-weight: bold;
                color: #1a1a1a;
            }

    /* 签名部分 */
    .signature-section {
        margin-top: 4mm;
        text-align: right;
    }

        .signature-section .signature-box {
            display: inline-block;
            text-align: center;
            margin-left: auto;
            padding-top: 3mm;
            position: relative;
        }

            .signature-section .signature-box::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 1px;
                background: linear-gradient(90deg, transparent, #1a2b50, transparent);
            }

        .signature-section .signature-title {
            font-weight: bold;
            margin-bottom: 1mm;
            color: #1a2b50;
            text-transform: uppercase;
            font-size: 14px;
            letter-spacing: 0.5px;
        }

        .signature-section .company-name {
            margin-bottom: 5mm;
            font-weight: bold;
            font-size: 15px;
        }

        .signature-section .signature-line {
            width: 80mm;
            border-bottom: 1px solid #b3b3b3;
            margin: 0 1mm 1mm 1mm;
            height: 25px;
        }

        .signature-section .signer-info {
            display: flex;
            justify-content: space-between;
            margin-top: 2px;
            font-size: 14px;
            color: #4d4d4d;
        }

            .signature-section .signer-info span {
                flex: 1;
            }

                .signature-section .signer-info span:first-child {
                    text-align: left;
                }

                .signature-section .signer-info span:last-child {
                    text-align: right;
                }

    /* 操作按钮 */
    .action-bar {
        margin-top: 10mm;
        text-align: center;
        padding-top: 10mm;
        border-top: 1px dashed #eee;
    }

        .action-bar .el-button {
            margin: 0 8px;
            min-width: 120px;
        }

            .action-bar .el-button + .el-button {
                margin-left: 8px;
            }

    /* 处理Element UI表格样式穿透 */
    .quotation-container > > > .el-table {
        font-size: 14px;
    }

        .quotation-container > > > .el-table.el-table--border {
            border: 1px solid #e6e6e6;
        }

    .quotation-container > > > th.el-table__cell {
        background-color: #f5f7fa;
        color: #1a2b50;
        font-weight: bold;
    }

        .quotation-container > > > th.el-table__cell.is-leaf {
            border-bottom: 1px solid #e6e6e6;
        }

    .quotation-container > > > td.el-table__cell {
        border-bottom: 1px solid #eee;
    }

    .quotation-container > > > .el-table .cell {
        padding: 8px 10px;
        line-height: 1.4;
    }

    /* 装箱单（PL）专业版式：双方块 / 装运信息 / 唛头 / 合计 / 备注 */
    .pl-sheet {
        margin-bottom: 3mm;
    }

    .pl-parties {
        display: flex;
        gap: 6mm;
        margin-bottom: 3mm;
    }

    .pl-party {
        flex: 1;
        border: 1px solid #999;
        padding: 2mm;
        min-height: 28mm;
    }

        .pl-party h4 {
            margin: 0 0 1.5mm 0;
            font-size: 13px;
            color: #1a2b50;
            border-bottom: 1px solid #ccc;
            padding-bottom: 1mm;
            text-transform: uppercase;
        }

        .pl-party-line {
            display: flex;
            font-size: 12px;
            line-height: 1.55;
            word-break: break-word;
        }

            .pl-party-line label {
                font-weight: bold;
                min-width: 18mm;
                flex: 0 0 18mm;
            }

            .pl-party-line span {
                flex: 1;
            }

    .pl-shipment {
        display: grid;
        grid-template-columns: 1fr 1fr;
        border: 1px solid #999;
        margin-bottom: 3mm;
    }

        .pl-shipment-item {
            display: flex;
            padding: 1.2mm 2mm;
            border-bottom: 1px dotted #ccc;
            font-size: 12px;
            line-height: 1.4;
        }

        .pl-shipment-item:nth-child(odd) {
            border-right: 1px solid #ccc;
        }

        .pl-shipment-item label {
            font-weight: bold;
            min-width: 40mm;
            flex: 0 0 40mm;
        }

        .pl-shipment-item span {
            flex: 1;
        }

    .pl-marks-box {
        border: 1px solid #999;
        padding: 2mm;
        margin-bottom: 3mm;
        min-height: 16mm;
        font-size: 12px;
    }

        .pl-marks-box label {
            font-weight: bold;
            display: block;
            margin-bottom: 1mm;
        }

    /* PL 明细表：列宽收紧（Case 55 / Model 90 / Qty 50 / Ctns 55 / N.W. 65 / G.W. 65 / Meas. 110 / Vol 75） */
    .pl-table ::v-deep(.el-table .cell) {
        padding: 2px 3px;
        line-height: 1.2;
    }

    .pl-table ::v-deep(th.el-table__cell) {
        padding: 3px 2px;
        font-size: 11px;
    }

    .pl-table ::v-deep(td.el-table__cell) {
        padding: 3px 2px;
        font-size: 11px;
    }

    .pl-totals {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: wrap;
        gap: 4mm;
        padding: 2mm 3mm;
        border: 1px solid #999;
        border-top: none;
        font-weight: bold;
        font-size: 12px;
        background-color: #f5f7fa;
    }

    .pl-remarks {
        margin-top: 3mm;
        border: 1px solid #999;
        padding: 2mm;
        font-size: 12px;
        line-height: 1.6;
    }

        .pl-remarks label {
            font-weight: bold;
            display: block;
            margin-bottom: 1mm;
        }

        .pl-remarks p {
            margin: 0.5mm 0;
        }

    /* 打印优化 */
    @media print {
        .quotation-container {
            font-size: 12px;
        }

        .header-top {
            margin-bottom: 8mm;
        }

        .company-header h1 {
            font-size: 20px;
        }

        .document-title {
            font-size: 20px;
            margin-bottom: 8mm;
        }

        .quotation-container > > > .el-table {
            font-size: 12px;
        }

            .quotation-container > > > .el-table .cell {
                padding: 6px 8px;
            }

        .signature-section {
            margin-top: 15mm;
        }

            .signature-section .signature-line {
                width: 60mm;
            }

        /* PL 版式打印收紧 */
        .pl-party-line, .pl-shipment-item, .pl-marks-box, .pl-remarks, .pl-totals {
            font-size: 10px;
        }

        .pl-parties {
            gap: 4mm;
        }

        .pl-sheet .pl-table ::v-deep(th.el-table__cell),
        .pl-sheet .pl-table ::v-deep(td.el-table__cell) {
            font-size: 10px;
            padding: 2px 2px;
        }
    }
</style>


